import React from "react";
import { Col, Row } from "reactstrap";
import profile from "../../assets/img/restaurantProfile.png";
import GoogleTranslate from "../../components/GoogleTranslate";

const RestaurantProfile = ({ restaurant }) => (
  <Row className="d-flex flex-column justify-content-center align-items-center">
    <Col className="d-flex justify-content-center align-items-center mb-3">
      <img
        className="restaurant__profile__img"
        src={restaurant?.restaurantLogo || profile}
        alt="restaurant profile"
      />
    </Col>
    <Col className="d-flex justify-content-center align-items-center mb-3">
      <h6 className="text-capitalize restaurant__profile__name">
        {restaurant?.name}
      </h6>
    </Col>
    <Col className="d-flex justify-content-center align-items-center mb-3">
      <GoogleTranslate />
    </Col>
  </Row>
);

export default RestaurantProfile;
